// Un servicio es de telemedicina si su color es BLANCO o GRIS.
// GRIS lo usa el destinatario 4 para identificar las contenciones (servicios
// creados con "Contención" desde Despachos), que se atienden igual que un
// BLANCO. Los demás destinatarios nunca tienen servicios GRIS, así que para
// ellos esto equivale a preguntar por BLANCO.
export function esTelemedicina(color) {
  return color === "BLANCO" || color === "GRIS";
}
